function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuperOver = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 1500",
    enableBackground: "new 0 0 612 792",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipRule: "evenodd",
      fill: "#ed1c24",
      fillRule: "evenodd",
      strokeWidth: 0.09486936
    },
    points: "393.252,364.146 361.118,330.593 251.231,330.416 217.504,364.146 302.271,466.223 ",
    transform: "matrix(10.540811,0,0,10.540811,-2292.6686,-3482.8526)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#fff200",
      fillRule: "evenodd",
      strokeWidth: 1
    },
    d: "m 155.40325,361.91884 236.55688,-244.46251 148.61491,1.8341 c -229.484,110.9526 -285.0868,261.5808 -247.17149,398.82216 z m 523.25643,629.2443 c 183.73689,50.34296 297.1244,58.63856 460.52812,8.4959 L 903.91683,1246.2297 Z M 366.98895,637.87729 558.76849,853.24716 C 587.90328,740.42885 890.88838,809.38685 917.47231,901.77705 1044.468,943.56083 1260.8814,872.46306 1263.9066,806.24568 1263.3163,646.52076 525.76521,779.03983 366.98895,637.87729 Z M 1499.7889,157.00546 1494.645,384.84511 h -298.7477 c 4.0477,-150.63874 -110.4255,-224.61416 -330.81282,-218.54265 -155.18184,3.03576 -304.29216,63.68758 -306.31599,163.77259 0,237.57936 835.54901,-19.20537 902.27241,312.3875 l 242.3122,-280.21694 z m -355.3518,-36.87176 158.4811,0.18973 -34.732,117.95169 c -29.2086,-71.414 -78.3815,-97.48142 -123.7491,-118.14142 z"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuperOver);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/super-over.19f2f96587b59c6abb8f06b6c3632eb0.svg";